export const SET_ALL_WIDGETS_EXPANDED = (state, expanded) => {
  state.allWidgetsExpanded = expanded;
};
